<div class="toggle-button-container" [class.toggle-button-container--compact]="isCompactMode()">
  <mat-slide-toggle
    [class.toggle--compact]="isCompactMode()"
    [disabled]="dataRow()?.role === 'READER' || !usernameExists()"
    [checked]="isActive()"
    (change)="
      movebankToggle($event, dataRow()?.role !== 'READER' && usernameExists(), dataRow()?.id)
    "
    aria-label="Auto forward new data to Movebank"
    matTooltip="Auto forward new data to Movebank"
  ></mat-slide-toggle>
  @if (!(dataRow()?.role === 'READER') && usernameExists()) {
    <button
      class="sync-btn"
      [class.sync-btn--compact]="isCompactMode()"
      mat-icon-button
      aria-label="Sync collar's data with Movebank"
      matTooltip="Sync collar's data with Movebank"
      (click)="
        onSyncCollarWithMovebank(dataRow()?.role !== 'READER' && usernameExists(), dataRow()?.id)
      "
    >
      <mat-icon>sync</mat-icon>
    </button>
  }
</div>
